export default {
  state: {
    name: ''
  },
};
